<script setup>
import { nextTick, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { appConfig } from './utils/config'

const route = useRoute()
const routeAnnouncement = ref('')

watch(
  () => route.fullPath,
  async () => {
    document.title = route.meta.title || appConfig.appTitle
    routeAnnouncement.value = route.meta.announcement || route.meta.title || ''

    await nextTick()
    const main = document.getElementById('main-content')
    if (main) {
      main.setAttribute('tabindex', '-1')
      main.focus({ preventScroll: true })
    }
  },
  { immediate: true },
)
</script>

<template>
  <a href="#main-content" class="skip-link">跳到主内容</a>
  <div class="sr-only" aria-live="polite" aria-atomic="true">{{ routeAnnouncement }}</div>
  <router-view />
</template>
